import React, { Component } from "react";
import { Panel, Button } from 'react-bootstrap';

export class LineColorSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openPanels: {},
            lineColors: {},
            pathColors: {},
            lineColorDisabled: {},
            originalLineColors: {},
            originalPathColors: {}
        };
    }

    componentDidMount() {
        let newOpenPanels = {};
        let initialLineColors = {};
        let initialPathColors = {};
        let initialLineColorDisabled = {};

        this.props.lines.forEach(line => {
            newOpenPanels[line.id] = true;

            initialLineColors[line.id] = (typeof line.backColor === "string" && line.backColor.startsWith("#"))
                ? line.backColor
                : this.numberToHexColor(line.backColor)

            initialLineColorDisabled[line.id] = false;

            const linePaths = this.getPathsForLine(line.id);
            linePaths.forEach(path => {
                initialPathColors[path.id] = (typeof path.backColor === "string" && path.backColor.startsWith("#"))
                    ? path.backColor
                    : initialLineColors[path.line.id];
            });
        });

        this.setState({
            openPanels: newOpenPanels,
            lineColors: initialLineColors,
            pathColors: initialPathColors,
            lineColorDisabled: initialLineColorDisabled,
            originalLineColors: { ...initialLineColors },
            originalPathColors: { ...initialPathColors }   
        }, () => {
            this.notifyColorChange();
        });
    }

    numberToHexColor(color) {
        if (typeof color !== "number") {
            return "#000"; 
        }

        const r = (color >> 16) & 0xFF;
        const g = (color >> 8) & 0xFF;
        const b = color & 0xFF;

        return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
    }

    getPathsForLine(lineId) {
        return this.props.paths.filter(path => path.line.id === lineId);
    }

    groupPathsByLine(paths, lines) {
        return lines.map(line => ({
            line: line,
            paths: paths.filter(path => path.line.id === line.id)
        }));
    }

    onPanelToggle(lineId) {
        this.setState(prev => ({
            openPanels: {
                ...prev.openPanels,
                [lineId]: !prev.openPanels[lineId]
            }
        }));
    }

    onLineColorChange(lineId, color) {
        const { lineColors, pathColors, lineColorDisabled } = this.state;

        const newLineColors = {
            ...lineColors,
            [lineId]: color
        };

        const linePaths = this.getPathsForLine(lineId);
        const newPathColors = { ...pathColors };
        linePaths.forEach(path => {
            newPathColors[path.id] = color;
        });

        const newLineColorDisabled = {
            ...lineColorDisabled,
            [lineId]: false
        };

        this.setState({
            lineColors: newLineColors,
            pathColors: newPathColors,
            lineColorDisabled: newLineColorDisabled
        }, () => {
            this.notifyColorChange();
        });
    }

    onPathColorChange(pathId, color) {
        const { pathColors, lineColorDisabled } = this.state;
        const path = this.props.paths.find(p => p.id === pathId);

        if (undefined === path) {
            return;
        }

        const newPathColors = {
            ...pathColors,
            [pathId]: color
        };

        const newLineColorDisabled = {
            ...lineColorDisabled,
            [path.line.id]: true
        };

        this.setState({
            pathColors: newPathColors,
            lineColorDisabled: newLineColorDisabled
        }, () => {
            this.notifyColorChange();
        });
    }

    notifyColorChange() {
        if (this.props.onColorsChange) {
            this.props.onColorsChange({
                lineColors: this.state.lineColors,
                pathColors: this.state.pathColors
            });
        }
    }

    resetLineColors(lineId) {
        const { originalLineColors, originalPathColors } = this.state;

        const originalLineColor = (originalLineColors && originalLineColors[lineId]) || "#000";

        this.onLineColorChange(lineId, originalLineColor);

        const linePaths = this.getPathsForLine(lineId);
        const newPathColors = { ...this.state.pathColors };

        linePaths.forEach(path => {
            newPathColors[path.id] =
                (originalPathColors && originalPathColors[path.id]) || originalLineColor;
        });

        this.setState({ pathColors: newPathColors }, () => {
            this.notifyColorChange();
        });
    }

    render() {
        const { paths, lines } = this.props;
        const { openPanels, lineColors, pathColors, lineColorDisabled } = this.state;

        const grouped = this.groupPathsByLine(paths, lines);

        return (
            <div>
                {grouped.map(group => {
                    const isOpen = openPanels[group.line.id];
                    const lineColor = lineColors[group.line.id] || "#000";
                    const isLineColorDisabled = lineColorDisabled[group.line.id];

                    return (
                        <Panel key={group.line.id} className="schematicmap-path-panel">
                            <Panel.Heading
                                onClick={() => this.onPanelToggle(group.line.id)}
                                className="schematicmap-path-panel-header"
                            >
                                <div className="schematicmap-header-left">
                                    <span className="schematicmap-line-title">
                                        {`${group.line.code} | ${group.line.goName}`}
                                    </span>
                                    <div
                                        className="schematicmap-line-color"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <input
                                            type="color"
                                            className="schematicmap-color-hidden"
                                            value={lineColor}
                                            disabled={isLineColorDisabled}
                                            onChange={(e) => this.onLineColorChange(group.line.id, e.target.value)}
                                        />
                                        <span
                                            className={`schematicmap-color-preview ${isLineColorDisabled ? "disabled" : ""}`}
                                            style={{ backgroundColor: lineColor }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!isLineColorDisabled) {
                                                    e.target.previousSibling.click();
                                                }
                                            }}
                                        />
                                        {isLineColorDisabled && (
                                            <Button
                                                bsSize="xs"
                                                className="schematicmap-reactivate-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.resetLineColors(group.line.id);
                                                }}
                                            >
                                                Aplicar a todos
                                            </Button>
                                        )}
                                    </div>
                                </div>
                                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                        bsSize="xs"
                                        className="schematicmap-reactivate-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.resetLineColors(group.line.id);
                                        }}>
                                        Repor Cores
                                    </Button>
                                    <span className={`schematicmap-dropdown-span ${isOpen ? "open" : "closed"}`} >
                                        ▶
                                    </span>
                                </div>
                            </Panel.Heading>

                            <Panel.Collapse in={isOpen}>
                                <div className="schematicmap-panel-collapse">
                                    {group.paths.length > 0 ? (
                                        <div className="schematicmap-paths">
                                            {group.paths.map((path, idx) => {
                                                const pathColor = pathColors[path.id] || lineColor;
                                                return (
                                                    <div
                                                        key={path.id}
                                                        className={`schematicmap-path-row ${idx % 2 === 0 ? "even" : "odd"}`}
                                                    >
                                                        <div className="schematicmap-path-info">
                                                            <span>
                                                                <strong>{path.code}</strong> {path.pathIdentifier}
                                                            </span>
                                                            <input
                                                                type="color"
                                                                className="schematicmap-color-hidden"
                                                                value={pathColor}
                                                                onChange={(e) => this.onPathColorChange(path.id, e.target.value)}
                                                            />
                                                            <span
                                                                className="schematicmap-color-preview"
                                                                style={{ backgroundColor: pathColor }}
                                                                onClick={(e) => e.target.previousSibling.click()}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="schematicmap-panel-collapse-no-info">
                                            Sem percursos disponíveis para esta linha.
                                        </div>
                                    )}
                                </div>
                            </Panel.Collapse>
                        </Panel>
                    );
                })}
            </div>
        );
    }


}